const cognito = {
    region: import.meta.env.VITE_COGNITO_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
    domain: import.meta.env.VITE_COGNITO_DOMAIN,
    redirectSignIn: import.meta.env.VITE_REDIRECT_SIGN_IN,
    redirectSignOut: import.meta.env.VITE_REDIRECT_SIGN_OUT,
};

export const getAuthUrls = () => {
    const baseUrl = `https://${cognito.domain}`;
    const params = `client_id=${cognito.userPoolWebClientId}&response_type=code&scope=openid+email+profile&redirect_uri=${encodeURIComponent(cognito.redirectSignIn)}`;

    return {
        signIn: `${baseUrl}/login?${params}`,
        signUp: `${baseUrl}/signup?${params}`,
        signOut: `${baseUrl}/logout?client_id=${cognito.userPoolWebClientId}&logout_uri=${encodeURIComponent(cognito.redirectSignOut)}`,
    };
};

export { cognito };
